import { render, staticRenderFns } from "./AddEditItem.vue?vue&type=template&id=3d536512&scoped=true&"
import script from "./AddEditItem.vue?vue&type=script&lang=js&"
export * from "./AddEditItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d536512",
  null
  
)

export default component.exports